export default {
  SET_PRODUCTS(state, products) {
    state.products = products
  },
  UPDATE_PRODUCT_PRICE(state, { productId, price }) {
    const product = state.products.find(p => p._id === productId)
    if (product) {
      product.price = price
    }
  },
  UPDATE_SAUCE_PRICE(state, { sauceName, price }) {
    state.products.forEach(product => {
      if (!product.sauces) return
      product.sauces.forEach(sauce => {
        if (sauce.name === sauceName) {
          sauce.price = price
        }
      })
    })
  },
}
